/**
 * La Nona Tita — lnt-blocks.js v3
 * Helpers compartidos para todos los bloques AI.
 * Cargado en theme.liquid con defer, antes de lnt-cart-instant.js.
 */

window.LntCart = (() => {
  async function addToCart(formData) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.description || 'Error al agregar al carrito');
    }
    // lnt-cart-instant.js detecta este fetch via hook y refresca el drawer automáticamente.
    return response.json();
  }

  return { addToCart };
})();

/**
 * Intercepta el CLICK del botón (no el submit del form) para evitar que
 * lnt-cart-instant.js también procese el mismo envío y muestre "Error".
 */
LntCart.bindForm = function (form, button) {
  if (!form || !button) return;
  button.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    const originalHTML = button.innerHTML;
    button.disabled = true;
    button.innerHTML = 'Agregando…';
    try {
      await LntCart.addToCart(new FormData(form));
    } catch (err) {
      console.error('[LntCart]', err.message);
    } finally {
      button.disabled = false;
      button.innerHTML = originalHTML;
    }
  });
};

/**
 * Maneja botones de agregar al carrito sin formulario.
 * El botón debe tener data-variant-id con el id de la variante.
 */
LntCart.bindButton = function (button) {
  if (!button) return;
  button.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    const variantId = button.dataset.variantId || button.getAttribute('data-variant-id');
    if (!variantId) return;
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    const originalHTML = button.innerHTML;
    button.disabled = true;
    button.innerHTML = 'Agregando…';
    try {
      await LntCart.addToCart(formData);
    } catch (err) {
      console.error('[LntCart]', err.message);
    } finally {
      button.disabled = false;
      button.innerHTML = originalHTML;
    }
  });
};
